// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___31BzX","inputContainer":"style__inputContainer___1E--q","birthDateInput":"style__birthDateInput___1vkNF","label":"style__label___1rxu0"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-forms/components/birthday-rounded-field/style.css
// module id = 1042
// module chunks = 0